import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModelWithUser } from './base';
import { EMessageChannel } from './message';
import { EModel } from './model';
export let ECampaignRef;
(function (ECampaignRef) {
  ECampaignRef["User"] = "user";
  ECampaignRef["Patient"] = "patient";
  ECampaignRef["Facility"] = "facility";
  ECampaignRef["Specialty"] = "specialty";
})(ECampaignRef || (ECampaignRef = {}));
export let ECampaignReadonlyChannel;
(function (ECampaignReadonlyChannel) {
  ECampaignReadonlyChannel["Email"] = "email";
})(ECampaignReadonlyChannel || (ECampaignReadonlyChannel = {}));
export let ECampaignLastUpdatedBy;
(function (ECampaignLastUpdatedBy) {
  ECampaignLastUpdatedBy["Patient"] = "patient";
  ECampaignLastUpdatedBy["Integrator"] = "integrator";
})(ECampaignLastUpdatedBy || (ECampaignLastUpdatedBy = {}));
export const fieldsCampaign = _extends({}, fieldsIBaseModelWithUser, {
  active: {
    type: 'Boolean'
  },
  channels: {
    type: 'Option',
    values: EMessageChannel,
    array: true
  },
  externalId: {
    type: 'Object'
  },
  externalRawSource: {
    type: 'Unknown'
  },
  lastUpdatedBy: {
    type: 'Option',
    values: ECampaignLastUpdatedBy
  },
  name: {
    type: 'Text'
  },
  readonlyChannels: {
    type: 'Option',
    values: ECampaignReadonlyChannel,
    array: true
  },
  ref: {
    type: 'Option',
    values: ECampaignRef
  },
  refId: {
    type: 'Text'
  },
  upload: {
    type: 'ID',
    ref: EModel.Upload
  }
});